import Dark from './dark';
import Light from './light';

export default {
  Dark,
  Light,
};
